import React from "react";
import { Card, IconTile, ProgressRow, SectionHeading, EmptyState } from "../ui";
import { Stagger, StaggerItem } from "../ui/motion";
import { sectionIcon, Grid } from "../icons";

/**
 * "Explore sections" — the role-based catalog, one card per section the learner
 * has permission to see.
 *
 * The old dashboard fronted these with stock photography, which said nothing
 * and aged badly. A line glyph plus the learner's own usage bar carries the
 * only two facts that matter: what it is, and how far in they are.
 *
 * Sections and their `totalPercentage` come from `/api/user-sections`; the
 * Intranet tile is appended because it's a permission-independent destination
 * the API doesn't enumerate.
 */
export const ExploreSections = ({ sections = [], onSelect }) => (
  <section className="ds-section">
    <SectionHeading
      title="Explore sections"
      description="Browse content by section. Each shows how much of it you've used."
    />

    {sections.length === 0 ? (
      <Card>
        <EmptyState
          icon={Grid}
          text="No sections have been made available to your role yet."
        />
      </Card>
    ) : (
      <Stagger className="ds-grid ds-grid--3">
        {sections.map((section) => {
          const Icon = sectionIcon(section.name);
          const pct = Number(section.totalPercentage) || 0;
          return (
            <StaggerItem key={section.name}>
              <Card interactive pad onClick={() => onSelect(section.name)}>
                <div className="ds-row-flex ds-gap-3">
                  <IconTile icon={Icon} />
                  <div className="ds-grow">
                    <h3 className="ds-h3 ds-truncate">{section.name}</h3>
                    <p className="ds-sub" style={{ marginTop: 2 }}>
                      Total module usage
                    </p>
                  </div>
                </div>
                <div className="ds-mt-4">
                  <ProgressRow value={pct} label={`${Math.round(pct)}%`} />
                </div>
              </Card>
            </StaggerItem>
          );
        })}
      </Stagger>
    )}
  </section>
);

export default ExploreSections;
